module.exports = "/images/good.svg?8c0d37b1697a637b6681d9439a210c32";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/good.svg
// module id = 85
// module chunks = 1